/**
 * @flow
 */

import Box from '@mui/material/Box';
import classNames from 'classnames';
import FormikCheckboxGroup from 'components/formik/CheckboxGroup';
import FormikRadioGroup from 'components/formik/RadioGroup';
import { Field } from 'formik';
import React from 'react';

const OPTION_CLASS = 'fill-form-option';
const OPTION_SELECTED_CLASS = 'fill-form-option-selected';
const OPTION_HORIZONTAL_CLASS = 'fill-form-option-horizontal';
const HORIZONTAL_GROUP_CLASS = 'fill-form-horizontal';

type Props = {
  question: Object,
  multiple?: boolean,
  items?: Array<[string, string]>,
  horizontal?: boolean,
};

const QuestionFormChoice = ({
  question,
  items = question.options.map(({ _id, label }) => [_id, label]),
  multiple = false,
  horizontal = false,
}: Props) => {
  const Component = multiple ? FormikCheckboxGroup : FormikRadioGroup;
  return (
    <Box
      sx={theme => ({
        [`& .${OPTION_CLASS}`]: {
          backgroundColor: theme.palette.primary.ultraLight,
          borderRadius: '4px',
          border: '2px solid transparent',
          margin: 0,
          padding: theme.spacing(1.25),
          marginTop: theme.spacing(0.75),
          marginBottom: theme.spacing(0.75),
          '&:hover': {
            border: `2px solid ${theme.palette.primary.lighter}`,
          },
        },
        [`& .${OPTION_SELECTED_CLASS}`]: {
          borderColor: theme.palette.primary.light,
          backgroundColor: theme.palette.primary.extraLight,
          '&:hover': {
            borderColor: theme.palette.primary.light,
          },
        },
        [`& .${OPTION_HORIZONTAL_CLASS}`]: {
          marginRight: theme.spacing(2),
          paddingRight: theme.spacing(4),
        },
        [`& .${HORIZONTAL_GROUP_CLASS}`]: {
          flexDirection: 'row',
        },
      })}
    >
      <Field
        type={multiple ? 'checkbox' : 'radio'}
        component={Component}
        itemClassName={classNames(OPTION_CLASS, { [OPTION_HORIZONTAL_CLASS]: horizontal })}
        itemSelectedClassName={OPTION_SELECTED_CLASS}
        name={`answers.${question._id}`}
        items={items}
        groupClassName={classNames({ [HORIZONTAL_GROUP_CLASS]: horizontal })}
      />
    </Box>
  );
};

export default QuestionFormChoice;
